<h2 mat-dialog-title>{{ 'SYSTEM_SPEED_DIALS.COPY_FROM_TITLE' | translate }}</h2>

<mat-dialog-content>
  <div class="context-card">
    <div class="card-label">{{ 'SYSTEM_SPEED_DIALS.COPY_SELECT_FROM' | translate }}</div>
    <div class="selects-row">
      <mat-form-field
        appearance="outline"
        class="density-minus-3">
        <mat-label>{{ 'SYSTEM_SPEED_DIALS.SITE' | translate }}</mat-label>
        <mat-select [(ngModel)]="fromSite">
          <mat-option [value]="null">{{ 'SYSTEM_SPEED_DIALS.ALL' | translate }}</mat-option>
          @for (s of sites; track s) {
            <mat-option [value]="s">{{ s }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
      <span class="or-label">{{ 'SYSTEM_SPEED_DIALS.OR' | translate }}</span>
      <mat-form-field
        appearance="outline"
        class="density-minus-3">
        <mat-label>{{ 'SYSTEM_SPEED_DIALS.DEPARTMENT' | translate }}</mat-label>
        <mat-select [(ngModel)]="fromDepartment">
          <mat-option [value]="null">{{ 'SYSTEM_SPEED_DIALS.ALL' | translate }}</mat-option>
          @for (d of departments; track d) {
            <mat-option [value]="d">{{ d }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>
  </div>

  <div class="context-card">
    <div class="card-label">{{ 'SYSTEM_SPEED_DIALS.COPY_SELECT_TO' | translate }}</div>
    <div class="selects-row">
      <mat-form-field
        appearance="outline"
        class="density-minus-3">
        <mat-label>{{ 'SYSTEM_SPEED_DIALS.SITE' | translate }}</mat-label>
        <mat-select [(ngModel)]="toSite">
          <mat-option [value]="null">{{ 'SYSTEM_SPEED_DIALS.ALL' | translate }}</mat-option>
          @for (s of sites; track s) {
            <mat-option [value]="s">{{ s }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
      <span class="or-label">{{ 'SYSTEM_SPEED_DIALS.OR' | translate }}</span>
      <mat-form-field
        appearance="outline"
        class="density-minus-3">
        <mat-label>{{ 'SYSTEM_SPEED_DIALS.DEPARTMENT' | translate }}</mat-label>
        <mat-select [(ngModel)]="toDepartment">
          <mat-option [value]="null">{{ 'SYSTEM_SPEED_DIALS.ALL' | translate }}</mat-option>
          @for (d of departments; track d) {
            <mat-option [value]="d">{{ d }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>
  </div>

  <div class="preview-card">
    <div class="card-label">{{ 'SYSTEM_SPEED_DIALS.COPY_PREVIEW' | translate }}</div>
    @if (previewDials.length > 0) {
      @for (dial of previewDials; track dial.id) {
        <div class="dial-row">
          @let contact = dial.type === ContentType.Contact ? (dial.content | contactById | async) : null;
          <div class="dial-avatar-wrap">
            @if (dial.type === ContentType.Contact) {
              <app-name-coin
                [contact]="contact"
                [sizeStyle]="'resizeable'"
                [img]="dial.avatar"
                [emoji]="dial.emoji"></app-name-coin>
            } @else if (dial.avatar) {
              <img
                class="dial-avatar"
                [src]="dial.avatar"
                [alt]="dial.button_name || dial.content" />
            } @else if (dial.emoji) {
              <span class="dial-emoji">{{ dial.emoji }}</span>
            } @else {
              <div
                class="dial-initials"
                [style.background-color]="dial.button_color || null">
                {{ speedDialService.getInitials(dial) }}
              </div>
            }
          </div>
          <div class="dial-info">
            <span class="dial-name">{{ dial.button_name || contact?.fullName || dial.content }}</span>
            <span class="dial-type">{{ dial.type }}</span>
          </div>
        </div>
      }
    } @else {
      <span class="no-dials">{{ 'SYSTEM_SPEED_DIALS.COPY_NO_DIALS' | translate }}</span>
    }
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button
    mat-button
    (click)="cancel()">
    {{ 'SYSTEM_SPEED_DIALS.CANCEL' | translate }}
  </button>
  <button
    mat-raised-button
    color="primary"
    [disabled]="previewDials.length === 0"
    (click)="confirm()">
    {{ 'SYSTEM_SPEED_DIALS.COPY_FROM_TITLE' | translate }}
  </button>
</mat-dialog-actions>
